"use strict";
var BandwidthHandler = require("./BandwidthHandler.js");
var sdpTransform = require("sdp-transform");

module.exports = optimize;
optimize.legacy = legacy;

function optimize(sdp, initiator, limit, multiplier) {
	// Settings based on https://www.webrtc-experiment.com/webrtcpedia/#manage-bitrates
	var bandwidth = {
		audio: 56,
		video: 256 * multiplier
	};

	// Only add bandwidth limit if initiator
	if(limit){
		if (initiator)
			sdp = BandwidthHandler.setApplicationSpecificBandwidth(sdp, bandwidth, false);

		sdp = BandwidthHandler.setVideoBitrates(sdp, {
			min: bandwidth.video,
			max: bandwidth.video,
		});
	}

	sdp = BandwidthHandler.setOpusAttributes(sdp, {
		"stereo": 0,
		"sprop-stereo": 0,
		"maxaveragebitrate": bandwidth.audio * 1024 * 8,
		"maxplaybackrate": bandwidth.audio * 1024 * 8,
		"cbr": 0,
		"useinbandfec": 1,
		"usedtx": 1,
		// "maxptime": 2,
	});

	sdp = setPreferedCodec(sdp);

	return sdp;
}

function setPreferedCodec(sdp){
	console.log("Prioritizing VP8 codec for video");
	var parsed = sdpTransform.parse(sdp);

	var media = parsed.media;
	var videoIndex = null;

	var videoMedia = media.filter(function(med, index){
		var isVideo = med.type === "video";
		if(isVideo) videoIndex = index;
		return isVideo;
	})[0];

	if(!videoMedia) return sdp;

	var mediaCodecs = videoMedia.rtp.filter(function(cod){
		return cod.codec === "VP8";
	})[0];

	if(!mediaCodecs) return sdp;

	var payloads = videoMedia.payloads;

	var codecPayload = mediaCodecs.payload + "";

	var newPayloads = payloads.split(" ").filter(function(p){
		return p !== codecPayload;
	});

	newPayloads.unshift(codecPayload);

	newPayloads = newPayloads.join(" ");

	parsed.media[videoIndex].payloads = newPayloads;

	return sdpTransform.write(parsed);
}

function legacy(sdp){
	var parsed = sdpTransform.parse(sdp);

	parsed.media.forEach(function(media){
		media.protocol = "RTP/SAVPF";
	});

	return sdpTransform.write(parsed);
}
